export default function Facebook(): JSX.Element {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Facebook</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5459 15.6843C16.5459 16.172 16.1505 16.5674 15.6629 16.5674L11.5857 16.5673L1.42895 16.5673C0.941143 16.5673 0.545898 16.172 0.545898 15.6843V1.45031C0.545898 0.962565 0.941143 0.567261 1.42895 0.567261H15.6629C16.1505 0.567261 16.5459 0.962505 16.5459 1.45031V15.6843ZM11.5857 10.3712V16.5673L9.09196 16.5673V10.3712H7.00688V7.95649H9.09196V6.17571C9.09196 4.10908 10.3541 2.98378 12.1977 2.98378C13.0807 2.98378 13.8398 3.04955 14.0609 3.07892V5.23864L12.7823 5.23924C11.7797 5.23924 11.5856 5.71566 11.5856 6.41478V7.95649H13.9768L13.6654 10.3712H11.5857Z"
        fill="currentColor"
      />
    </svg>
  )
}

try{ Facebook.displayName ||= 'Facebook' } catch {}